import ProjectResults from './ProjectResultsContainer';

export default ProjectResults;
